import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { SkagCreditApplicationsTableDefinitionZod } from '../tables';

type Arguments = {
    loanRequestId: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetSkagCreditApplication = SkagCreditApplicationsTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetSkagCreditApplication = z.infer<
    typeof schemaLoanRequestResolver_GetSkagCreditApplication
>;

export type LoanRequestResolver_GetSkagCreditApplication = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetSkagCreditApplication
>;
